'use strict';

/**
 * Updates the shared search results item count when switching between Products and Articles tabs.
 */
module.exports = function () {
	if (!$('.lvz-search-result-count-row').length) {
		return;
	}

	function getCountRow() {
		return $('.lvz-search-result-count-row');
	}

	function formatCount(count) {
		return String(getCountRow().data('countTemplate')).replace('{0}', count);
	}

	function setCount(count) {
		getCountRow().find('[data-lvz-search-item-count]').text(formatCount(count));
	}

	function toggleQuickFiltersCount(visible) {
		$('.lvz-quick-filters__count').toggleClass('d-none', !visible);
	}

	function readContentCount() {
		var $marker = $('#content-search-results').find('[data-lvz-content-item-count]').first();

		if (!$marker.length) {
			return null;
		}

		return parseInt($marker.attr('data-lvz-content-item-count'), 10) || 0;
	}

	$(document).on('shown.bs.tab', '.lvz-plp-header-banner__tab', function (e) {
		if ($(e.target).hasClass('product-search')) {
			getCountRow().addClass('d-none');
			toggleQuickFiltersCount(true);
		} else if ($(e.target).hasClass('content-search')) {
			var contentCount = readContentCount();
			toggleQuickFiltersCount(false);

			if (contentCount !== null) {
				setCount(contentCount);
				getCountRow().removeClass('d-none');
			}
		}
	});

	$(document).on('click', '.content-search', function () {
		if ($('#content-search-results').html() === '') {
			$(document).one('ajaxComplete', function (event, xhr, settings) {
				if (settings.url && settings.url.indexOf('Search-Content') !== -1) {
					var contentCount = readContentCount();

					if (contentCount !== null) {
						setCount(contentCount);
						getCountRow().removeClass('d-none');
						toggleQuickFiltersCount(false);
					}
				}
			});
		}
	});
};
